import { createStore } from 'vuex'
import user from './user'
import response from './response'
import page from './page'
import channel from './channel'
import inventory from './inventory'
import invoice from './invoice'
import netmanager from './net-manager'
import sales from './sales'
import servicestate from './service-state'
import systemsettings from './system-settings'
import erpfields from './erp-fields'
import logs from './logs'
import regcustomer from './regcustomer'
import listPrice from './list-price'
import sendOrder from './send-order';
import materialData from './material-data';
import materialComp from './material-comp';
import quotaion from './quotaion';
import quotaionOms from './quotaion-oms';
import purchaseOrder from './purchase-order';
import sendPurchaseOrder from './send-purchase-order';
import orderConfirmation from './order-confirmation';
import shippingNotice from './shipping-notice';
import inventoryInformation from './inventory-information';
import downstreamSales from './downstream-sales';
import proformaInvoice from './proforma-invoice';
import deliveryDetails from './delivery-details';
import purchaseReceipt from './purchase-receipt';
const store = createStore({
    modules: {
        purchaseReceipt,
        proformaInvoice,
        downstreamSales,
        inventoryInformation,
        orderConfirmation,
        purchaseOrder,
        sendPurchaseOrder,
        deliveryDetails,
        quotaion,
        quotaionOms,
        sendOrder,
        materialData,
        materialComp,
        listPrice,
        shippingNotice,
        user,
        page,
        logs,
        sales,
        channel,
        inventory,
        response,
        netmanager,
        invoice,
        erpfields,
        systemsettings,
        servicestate,
        regcustomer,

    }
})


export default store
